import Boxes from "@icons/boxes.svg?react";
import Eco from "@icons/eco.svg?react";
import Feeds from "@icons/feeds.svg?react";
import MarketPlaceSvg from "@icons/marketplace.svg?react";
import Oil from "@icons/oil.svg?react";
import PlantProtection from "@icons/plant-protection.svg?react";
import Seeds from "@icons/seeds.svg?react";
import React from "react";

import { CropCategory } from "@/generated/digitalnisklady.cz/graphql";

const categoryIconMap: Record<
  CropCategory,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  [CropCategory.Fertilizer]: MarketPlaceSvg,
  [CropCategory.Feed]: Feeds,
  [CropCategory.PlantProtection]: PlantProtection,
  [CropCategory.Fuel]: Oil,
  [CropCategory.Seed]: Seeds,
  [CropCategory.Eko]: Eco,
  [CropCategory.Crop]: Boxes,
};

const CategoryIcon = ({
  category,
  className,
}: {
  category: CropCategory;
  className?: string;
}) => {
  const Icon = categoryIconMap[category];

  return <Icon className={className} />;
};

export { CategoryIcon };
